import type { FC } from "react";

import { DynamicPropertiesSearchForm } from "src/app/features/DynamicProperty/components/forms/DynamicPropertiesSearchForm";
import { DynamicPropertiesTable } from "src/app/features/DynamicProperty/components/tables/DynamicPropertiesTable";
import type { DynamicPropertyEntity } from "src/app/features/DynamicProperty/types/DynamicPropertyEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const DynamicPropertiesPage: FC<NoneOwnProps> = () => {
    const table = <DynamicPropertiesTable />;
    const searchForm = <DynamicPropertiesSearchForm />;
    const hasAccess = canAccess(ResourceName.DYNAMIC_PROPERTIES, "canRead");

    return (
        <PageLayout name="dynamicProperties_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.dynamicProperties" />
                    <ResourceManager<DynamicPropertyEntity>
                        useDataGroup={false}
                        dataMapperKey="dynamicPropertiesTableData"
                        resource={ResourceName.DYNAMIC_PROPERTIES}
                        table={table}
                        actions={[Actions.ADD, Actions.DELETE]}
                        searchForm={searchForm}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
